import React, { useEffect, useState } from "react";
import Modalheader from "components/modal/components/header";
import ModalBody from "components/modal/components/body";
import ModalFooter from "components/modal/components/footer";
import Button from "components/button";
import useModal from "components/modal/useModal";
import DatePicker from "react-datepicker";
import UseContext from "hooks/useContext";
import { Information } from "assets/icons";
import StyledInput from "components/styledInput/StyledInput";
import StyledDateInput from "components/styledInput/StyledDateInput";
import { FormField } from "pages/createMission/components/SectionWrapper";

const AttenteRecrutement = () => {
    const { data, setData, language } = UseContext();
    const label = (key, defaultValue) =>
        language.getValue(`missionCreation.motifForm.${key}`, defaultValue);
    // Reopening the modal shows the motif already confirmed, as long as it is this one.
    const [message, setMessage] = useState(() => {
        const savedMotif = data.motif?.type === "2" ? data.motif : {};
        return {
            type: "2",
            name: savedMotif.name ?? "",
            prenom: savedMotif.prenom ?? "",
            date: savedMotif.date ?? "",
        };
    });
    const [errorName, setErrorName] = useState(false);
    const [errorPrenom, setErrorPrenom] = useState(false);
    const [errorDate, setErrorDate] = useState(false);

    const { toggle } = useModal();

    const handleChange = (name) => (e) => {
        const value = e.target.value;

        setMessage((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };
    const handleSubmit = () => {
        if (
            message.name === "" ||
            message.prenom === "" ||
            message.date === ""
        ) {
            if (message.name === "") {
                setErrorName(true);
            } else {
                setErrorName(false);
            }
            if (message.prenom === "") {
                setErrorPrenom(true);
            } else {
                setErrorPrenom(false);
            }
            if (message.date === "") {
                setErrorDate(true);
            } else {
                setErrorDate(false);
            }
        } else {
            setErrorName(false);
            setErrorPrenom(false);
            setErrorDate(false);
            setData((prevData) => ({ ...prevData, motif: message }));
            toggle();
        }
    };
    return (
        <>
            <Modalheader
                hide={toggle}
                hideShow={true}
                closeLabel={language.getValue("missionCreation.modal.close", "Fermer")}
                description={label("reasonDescriptions.awaitingRecruitment", "Pour occuper un poste en attendant l'arrivée d'un salarié recruté en CDI. Indiquez la personne recrutée et sa date d'entrée prévue.")}
            >
                En attente de recrutement
            </Modalheader>
            {/*body*/}
            <ModalBody>
                <div className={"grid grid-cols-2 gap-6"}>
                    <div className={"flex flex-col gap-1.5"}>
                        <StyledInput
                            type={"text"}
                            label={label("name", "Nom")}
                            value={message.name}
                            onChange={handleChange("name")}
                        />
                        {errorName ? (
                            <p className="text-yellow-400 flex  items-center gap-4">
                                <Information wh={16} color={"#FFA43D"} />
                                {label("nameMissing", "Un nom est requis")}
                            </p>
                        ) : (
                            ""
                        )}
                    </div>
                    <div className={"flex flex-col gap-1.5"}>
                        <StyledInput
                            type={"text"}
                            label={label("firstname", "Prénom")}
                            value={message.prenom}
                            onChange={handleChange("prenom")}
                        />
                        {errorPrenom ? (
                            <p className="text-yellow-400 flex  items-center gap-4">
                                <Information wh={16} color={"#FFA43D"} />
                                {label("firstnameMissing", "Un prénom est requis")}
                            </p>
                        ) : (
                            ""
                        )}
                    </div>
                    <div className={"col-span-2"}>
                        <FormField label={label("date", "Date")}>
                            <DatePicker
                                dateFormat="dd/MM/yyyy"
                                selected={message.date}
                                onChange={(date) =>
                                    setMessage({
                                        ...message,
                                        date: date,
                                    })
                                }
                                peekNextMonth
                                locale="fr-FR"
                                showMonthDropdown
                                showYearDropdown
                                dropdownMode="select"
                                popperPlacement="bottom"
                                customInput={<StyledDateInput />}
                            />
                        </FormField>
                        {errorDate ? (
                            <p className="text-yellow-400 flex  items-center gap-4">
                                <Information wh={16} color={"#FFA43D"} />
                                {label("dateMissing", "Une date est requise")}
                            </p>
                        ) : (
                            ""
                        )}
                    </div>
                </div>
            </ModalBody>
            {/*footer*/}
            <ModalFooter>
                <Button size={"LG"} color={"SECONDARY"} onClick={toggle}>
                    Annuler
                </Button>
                <Button size={"LG"} onClick={handleSubmit}>
                    Confirmer
                </Button>
            </ModalFooter>
        </>
    );
};

export default AttenteRecrutement;
